import axios from 'axios';

// const API_BASE_URL = 'http://145.223.82.243/api/';

const API_BASE_URL = 'https://admin.jidarcompany.com/api';


export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});